import React, { useState } from "react";
import config from "../config/configValues";
import FileInput from "./FileInput";
import ImageCropper from "./ImageCropper";
import Modal from 'react-modal';
import uploadFile from '../config/uploadFile';

const Step2 = ({
    className,
    formData,
    handleChange,
    handleLabelChange,
    nextStep,
    handleImageUpdate,
    prevStep,
    handleKeyUp,
    changeDisplayToTrue }) => {

    const [currentPage, setCurrentPage] = useState("choose-img");
    const [image, setImage] = useState("");
    const [imgAfterCrop, setImgAfterCrop] = useState("");
    const [modalIsOpen, setIsOpen] = useState(false);

    const customStyles = {
        content: {
            top: '30%',
            left: '30%',
            right: 'auto',
            bottom: 'auto',
            marginTop: '5%',
            width: '50%',
            height: '80%',
            transform: 'translate(-30%, -30%)',
        },
    };

    const onImageSelected = (selectedImg) => {
        setImage(selectedImg);
        setCurrentPage("crop-img");
        setIsOpen(true)
    };

    // Callback function when cropping is done
    const onCropDone = (imgCroppedArea) => {

        // Create a canvas element to crop the image
        const canvasEle = document.createElement("canvas");
        canvasEle.width = imgCroppedArea.width;
        canvasEle.height = imgCroppedArea.height;

        const context = canvasEle.getContext("2d");

        // Load the selected image
        let imageObj1 = new Image();
        imageObj1.src = image;
        imageObj1.onload = async function () {
            // Draw the cropped portion of the image onto the canvas
            context.drawImage(
                imageObj1,
                imgCroppedArea.x,
                imgCroppedArea.y,
                imgCroppedArea.width,
                imgCroppedArea.height,
                0,
                0,
                imgCroppedArea.width,
                imgCroppedArea.height
            );

            // Convert the canvas content to a data URL (JPEG format)
            const dataURL = canvasEle.toDataURL("image/jpeg");

            console.log("dataURL : ", dataURL)

            setImgAfterCrop(dataURL);
            setCurrentPage("img-cropped");
            // uploading to the server 
            const fileName = await uploadFile(dataURL);
            handleImageUpdate(fileName)
            setIsOpen(false)
        };
    };
    const onCropCancel = () => {
        setCurrentPage("choose-img");
        setImage("");
    };

    return (
                <div className={`card-body ${className}`}>
                    <div className="form-row mb-2" >
                        {currentPage === "choose-img" ? (
                            <FileInput onImageSelected={onImageSelected} />
                        ) : currentPage === "crop-img" ? (
                            <Modal
                                isOpen={modalIsOpen}
                                // onAfterOpen={afterOpenModal}
                                // onRequestClose={closeModal}
                                style={customStyles}
                                contentLabel="Example Modal"
                            >
                                <ImageCropper
                                    image={image}
                                    onCropDone={onCropDone}
                                    onCropCancel={onCropCancel}
                                /></Modal>
                        ) : (
                            // Display the cropped image and options to crop a new image or start over
                            <div>
                                <div>
                                    <img src={imgAfterCrop} className="cropped-img" width="200" height="200" alt="image_after" />
                                </div>

                                <button className="btn" onClick={() => { setCurrentPage("crop-img"); }}>Crop</button>
                                &nbsp;&nbsp;
                                <button className="btn" onClick={() => {
                                    // Start over by choosing a new image
                                    setCurrentPage("choose-img");
                                    setImage("");
                                }}>New Image</button>
                            </div>
                        )}
                        {formData.map((object, index) => (

                            <div key={index}>
                                {
                                    object.label === "address" && (
                                        <div className="col-lg-12 card-header text-center" style={{ background: "rgba(252, 247, 252, 0.3)" }}>
                                            <h5 className="card-title" >संपर्क</h5>
                                        </div>
                                    )
                                }
                                <div className="form-group mb-2">
                                    <div className="form-group">
                                        <div className="d-flex align-items-center mr-5">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id={`input${object.label}Label`}
                                                style={config.labelStyle}
                                                value={object.labelTitle}
                                                onChange={(e) => handleLabelChange(e, index)}
                                                onKeyUp={(e) => handleKeyUp(e, { inputType: "labelTitle", index: index, key: e.key })}
                                            />
                                            { !object.mandatory && <i className="bi bi-x-lg text-danger" onClick={(e) => changeDisplayToTrue(index)}></i>}
                                           
                                        </div>
                                        <input
                                            type={object.dataType}
                                            className="form-control"
                                            name={object.label}
                                            id={`input${object.label}`}
                                            placeholder={object.placeholder}
                                            value={object.value}
                                            onChange={(e) => handleChange(e, index)}
                                            onKeyUp={(e) => handleKeyUp(e, { inputType: "value", index: index, key: e.key })}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="form-group d-flex justify-content-around my-4">

                            <button className="btn btn-primary" type="button" onClick={prevStep}>
                                Previous Page
                            </button>
                            <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <button className="btn btn-primary" type="button" onClick={nextStep}>
                                Next Page
                            </button>

                        </div>
                    </div>
                </div>
    );
}
export default Step2;